import { useEffect, useState } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
// import dayjs, { Dayjs } from "dayjs";
import "./style.css";
import { useSelector } from "react-redux";
import {
  disabledIfFieldChecker,
  findDataInFields,
} from "../../../utils/helperFuctions";
import { DateTime } from "luxon";
import moment from "moment-timezone";

export default function InputDateTimePickerMUI({
  label,
  name,
  id,
  placeholder,
  defaultValue,
  err,
  handleChange,
  minDate,
  relatedWith,
  isClearable,
  disabled,
  allowTime,
  required,
  countryBranchCode,
  isItPickup,
  disabledIfField,
  minValueFrom,
  minValueFromObj,
  useMaxDateTheDefaultValueIf,
  reduceMinDateDays,
  wrapperStyle,
  disableInput,
}) {
  const fields = useSelector((state) => state.showFields);
  let countryCode = null;
  if (countryBranchCode != null) {
    countryCode = findDataInFields(fields, countryBranchCode);
  }
  // if (countryBranchCode !== null) {
  //   countryCode = countryBranchCode;
  // }
  // let useMaxDate = null;
  // if (useMaxDateTheDefaultValueIf != null) {
  //   useMaxDate = findDataInFields(fields, useMaxDateTheDefaultValueIf.field);
  // }
  const timezone = countryCode === "LB" ? "Asia/Beirut" : "Asia/Dubai";
  let minDate2;
  if (minValueFrom != null) {
    const minValue = findDataInFields(fields, minValueFrom);

    minDate2 = fromUtcToBranchCodeTime(minValue, 0).split("T")[0];
  }
  if (minValueFromObj != null) {
    const values = findDataInFields(fields, minValueFromObj.field);
    if (Array.isArray(values) && values.length > 0) {
      if (minValueFromObj.array_item === "last") {
        const lastItem = values[values.length - 1];
        minDate2 = fromUtcToBranchCodeTime(
          lastItem[minValueFromObj.subField],
          1
        ).split("T")[0];
      } else {
        minDate2 = fromUtcToBranchCodeTime(
          values[values.length - 1][minValueFromObj.subField],
          1
        ).split("T")[0];
      }
    }

    // minDate2 = fromUtcToBranchCodeTime(minValue, 1).split("T")[0];
  }
  const [errorMessage, setErrorMessage] = useState(err);

  // Normalize defaultValue so that downstream logic always works with a string,
  // and avoid calling .includes on non‑string values (e.g. booleans from filters).
  let normalizedDefaultValue = null;
  if (typeof defaultValue === "string") {
    normalizedDefaultValue = defaultValue;
  } else if (
    defaultValue instanceof Date ||
    (defaultValue &&
      typeof defaultValue === "object" &&
      typeof defaultValue.toISOString === "function")
  ) {
    // Support Date or date-like objects (e.g. Moment/Luxon with toISOString)
    normalizedDefaultValue = defaultValue.toISOString();
  } else if (
    defaultValue !== null &&
    defaultValue !== undefined &&
    typeof defaultValue !== "boolean"
  ) {
    // Fallback for number/other primitives – treat as string
    normalizedDefaultValue = String(defaultValue);
  } else {
    normalizedDefaultValue = null;
  }

  const withTimeAllowed = normalizedDefaultValue
    ? normalizedDefaultValue.includes("Z") ||
      normalizedDefaultValue.includes("+")
      ? fromUtcToBranchCodeTime(normalizedDefaultValue)
      : fromUtcToBranchCodeTime(normalizedDefaultValue + "Z")
    : null;

  const withTimeNotAllowed = normalizedDefaultValue
    ? normalizedDefaultValue.includes("Z") ||
      normalizedDefaultValue.includes("+")
      ? new Date(normalizedDefaultValue + "T00:00:00Z")
      : new Date(normalizedDefaultValue + "T00:00:00Z")
    : null;
  const initDate = (defaultValue, minDate, relatedWith) => {
    const newDate = defaultValue
      ? moment
          .utc(allowTime === true ? defaultValue + "Z" : withTimeNotAllowed)
          .tz(timezone)
      : null;
    return newDate;
  };

  function fromBranchCodeTimeToUtc(localTimeString) {
    const momentObj = moment.tz(localTimeString.split("+")[0], timezone);
    const utcTime = momentObj.utc().toISOString();
    if (allowTime === false || allowTime == null) {
      return utcTime.split("T")[0];
    }
    return utcTime;
  }
  function fromUtcToBranchCodeTime(time, daysAdded) {
    if (allowTime === false || allowTime == null) {
      const newT = time.slice(0, time.length - 1) + "Z00:00:00Z";
      let utcDateTime = DateTime.fromISO(newT, { zone: "utc" });

      // Add days if `daysAdded` is defined and not null
      if (daysAdded != null) {
        utcDateTime = utcDateTime.plus({ days: daysAdded });
      }

      const formattedDate = utcDateTime.toFormat("yyyy-MM-dd");
      return formattedDate;
    }

    // Create a DateTime object from the UTC time string
    let utcDateTime = DateTime.fromISO(time, { zone: "utc" });

    // Add days if `daysAdded` is defined and not null
    if (daysAdded != null) {
      utcDateTime = utcDateTime.plus({ days: daysAdded });
    }

    // Convert the UTC DateTime to the specified time zone
    const localDateTime =
      allowTime === true ? utcDateTime.setZone(timezone) : utcDateTime;

    const formattedDate = localDateTime.toFormat("yyyy-MM-dd");
    const formattedTime = localDateTime.toFormat("HH:mm:ss.SSS");

    return `${formattedDate}T${formattedTime}Z`;
  }

  const [value, setValue] = useState(initDate(defaultValue));

  const isFieldDisabled =
    disabled === true
      ? disabledIfField
        ? disabledIfFieldChecker(fields, {
            field: disabledIfField.field,
            valuesArray: disabledIfField.isEqual,
          })
        : true
      : disabled === false
      ? false
      : disabledIfField != null
      ? disabledIfFieldChecker(fields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : false;

  const inputChange2 = (e) => {
    let _e;
    if (e) {
      _e = {
        target: {
          name: name,
          value:
            allowTime === false
              ? e.format().split("T")[0]
              : fromBranchCodeTimeToUtc(e.format(), countryCode),
          minParam: minDate,
          maxParam: relatedWith,
        },
      };
    } else {
      _e = {
        target: {
          name: name,
          value: e,
          minParam: minDate,
          maxParam: relatedWith,
        },
      };
    }

    if (handleChange instanceof Function) handleChange(_e);
  };

  return (
    <div>
      <label
        htmlFor={name}
        data-related="blabla"
        className="text-left block text-sm font-medium leading-6 text-gray-900"
      >
        {label}
        {required ? "*" : ""}
      </label>

      <div
        style={{ ...wrapperStyle }}
        className={`relative mt-2 rounded-md shadow-sm datepicker ${
          isFieldDisabled && "bg-[#F9FAFB]"
        }`}
      >
        <LocalizationProvider dateAdapter={AdapterMoment}>
          {allowTime ? (
            <DateTimePicker
              //label="Controlled picker"
              value={value}
              onChange={inputChange2}
              // viewRenderers={{
              //   hours: renderTimeViewClock,
              //   minutes: renderTimeViewClock,
              //   seconds: renderTimeViewClock
              // }}
              views={["year", "month", "day", "hours", "minutes"]}
              format={"DD-MM-YYYY hh:mm A"}
              slotProps={{
                field: { clearable: isClearable ? true : false },
                textField: {
                  InputProps: {
                    disabled:
                      isFieldDisabled === true ||
                      (disableInput != null && disableInput === true)
                        ? true
                        : false,
                  },
                },
              }}
              minDate={
                minDate2 != null
                  ? moment(minDate2).subtract(
                      reduceMinDateDays != null ? reduceMinDateDays : 0,
                      "days"
                    )
                  : undefined
              }
              disabled={isFieldDisabled}
              className="w-full text-sm"
              name={name}
            />
          ) : (
            <DatePicker
              value={value}
              onChange={inputChange2}
              format={"DD-MM-YYYY"}
              slotProps={{
                field: { clearable: isClearable ? true : false },
              }}
              disabled={isFieldDisabled}
              views={["year", "month", "day"]}
              InputProps={{
                classes: "testing",
              }}
              maxDate={moment().add(150, "y")}
              className={`w-full text-sm`}
              name={name}
            />
          )}
        </LocalizationProvider>
        {err && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <ExclamationCircleIcon
              className="h-5 w-5 text-red-500"
              aria-hidden="true"
            />
          </div>
        )}
      </div>
      {err && <p className="text-left mt-2 text-sm text-red-600">{err}</p>}
    </div>
  );
}
